module.exports = __webpack_public_path__ + "fonts/SFProText-Medium.09be2e2f.woff2";